import { render, staticRenderFns } from "./OrgnzSearch.vue?vue&type=template&id=19cc98f6&"
import script from "./OrgnzSearch.vue?vue&type=script&lang=js&"
export * from "./OrgnzSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports